/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suave_Dull_Mantis_PatInputs */

const fr_suave_dull_mantis_pat = /** @type {(inputs: Suave_Dull_Mantis_PatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systeme`)
};

/**

* @param {Suave_Dull_Mantis_PatInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const suave_dull_mantis_pat = /** @type {((inputs?: Suave_Dull_Mantis_PatInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suave_Dull_Mantis_PatInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_suave_dull_mantis_pat(inputs)
});